import styled from 'styled-components'

const Inner = styled.div`
  flex-grow: 1;
  width: 100%;
`

export default Inner
